import { createTheme } from '@mui/material/styles';

const irWorkstationTheme = createTheme({
	palette: {
		primary: {
			main: '#378add',
		},
		background: {
			default: '#f1f0ec',
			paper: '#ffffff',
			subtle: '#f7f7f5',
		},
		text: {
			primary: '#1a1a18',
			secondary: '#6b6b67',
			tertiary: '#a8a8a4',
		},
		divider: 'rgba(0,0,0,0.1)',
		border: {
			light: 'rgba(0,0,0,0.1)',
			main: 'rgba(0,0,0,0.18)',
		},
		status: {
			blue: {
				bg: '#e6f1fb',
				text: '#0c447c',
				border: '#b5d4f4',
				hover: '#d4e8f8',
				icon: '#185fa5',
			},
			green: { bg: '#eaf3de', text: '#27500a' },
			amber: { bg: '#faeeda', text: '#633806' },
			red: { bg: '#fcebeb', text: '#791f1f' },
			teal: { bg: '#e1f5ee', text: '#085041' },
			gray: { bg: '#f1efe8', text: '#444441' },
		},
		vdr: {
			bg: '#f0ecff',
			text: '#4c1d95',
			border: '#c4b5fd',
			accent: '#7c3aed',
			hover: '#e4daff',
		},
		row: {
			featured: { bg: '#f5f9ff', hover: '#edf5ff' },
			vdrSourced: { bg: '#faf8ff' },
			vdrFeatured: { bg: '#f5f0ff', hover: '#ede6ff' },
		},
		signal: {
			red: '#e24b4a',
			amber: '#ef9f27',
			green: '#1d9e75',
			gray: '#b4b2a9',
			blue: '#0288d1',
		},
		score: {
			down: '#a32d2d',
			up: '#27500a',
			warn: '#854f0b',
		},
		commitmentByStage: {
			initialContact: '#9CA3AF',
			ppmSent: '#60A5FA',
			inDiscussions: '#2DD4BF',
			waiting: '#FBBF24',
			lost: '#F87171',
			commitmentWon: '#4ADE80',
		},
	},
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
		fontSize: 13,
		h1: { fontSize: '17px', fontWeight: 600 },
		h2: { fontSize: '14px', fontWeight: 600 },
		h3: { fontSize: '13px', fontWeight: 600 },
		body1: { fontSize: '13px', lineHeight: 1.45 },
		body2: { fontSize: '12px', lineHeight: 1.45 },
		caption: { fontSize: '11px', lineHeight: 1.4 },
		overline: {
			fontSize: '10px',
			fontWeight: 600,
			letterSpacing: '0.07em',
			textTransform: 'uppercase',
		},
		button: { textTransform: 'none', fontWeight: 500, fontSize: '12px' },
	},
	shape: {
		borderRadius: 8,
	},
	spacing: 4,
	layout: {
		navHeight: 52,
		sidebarWidth: 200,
	},
	components: {
		MuiCssBaseline: {
			styleOverrides: {
				'*, *::before, *::after': { boxSizing: 'border-box' },
				body: { margin: 0, padding: 0 },
				'::-webkit-scrollbar': { width: '4px' },
				'::-webkit-scrollbar-track': { background: 'transparent' },
				'::-webkit-scrollbar-thumb': {
					background: 'rgba(0,0,0,0.18)',
					borderRadius: '2px',
				},
			},
		},
		MuiAppBar: {
			defaultProps: { elevation: 0 },
			styleOverrides: {
				root: {
					backgroundColor: '#ffffff',
					color: '#1a1a18',
					borderBottom: '0.5px solid rgba(0,0,0,0.18)',
					borderRadius: 0,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					fontWeight: 500,
					fontSize: '12px',
					borderRadius: 6,
					padding: '5px 12px',
				},
			},
		},
		MuiDrawer: {
			styleOverrides: {
				paper: {
					borderLeft: '0.5px solid rgba(0,0,0,0.18)',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 12,
				},
			},
		},
	},
});

export default irWorkstationTheme;
